/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserDto { 
    id?: number;
    phone?: string;
    email?: string;
    firstname?: string;
    lastname?: string;
    patronymic?: string;
    asteriskId?: string;
    enabled?: boolean;
    removed?: boolean;
    createDate?: string;
    modifyDate?: string;
    keycloakId?: string;
    position?: string;
    admin?: boolean;
    hireDate?: string;
    terminationDate?: string;
}

